import React from "react"
import Box from "@material-ui/core/Box"
import Container from "@material-ui/core/Container"
import Typography from "@material-ui/core/Typography"
import MuiBreadcrumbs from "@material-ui/core/Breadcrumbs"
// import EventNoteIcon from "@material-ui/icons/EventNote"

import { graphql, Link } from "gatsby"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Seo from "../components/seo"
import Layout from "../components/layout"

const Breadcrumbs = withStyles(theme => ({
  separator: {
    color: theme.palette.common.white,
  },
}))(MuiBreadcrumbs)

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(25),
    paddingBottom: theme.spacing(12.5),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(8),
    },
  },
  container: {},
  image: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  date: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  body: {},
  link: {
    color: theme.palette.common.white,
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
      color: theme.palette.common.white,
    },
    "&:hover:active": {
      textDecoration: "none",
      color: theme.palette.common.white,
    },
  },
  text: {
    color: theme.palette.common.white,
    textDecoration: "none",
  },
}))

const SingleBlog = props => {
  const classes = useStyles()
  const {
    data: { datoCmsNews },
  } = props
  const { title, seo = {}, description, image } = datoCmsNews

  return (
    <Layout bgColor="#B136FF">
      <Seo title={seo?.title} description={seo?.description} />
      <Box className={classes.root}>
        <Container maxWidth="md" className={classes.container}>
          <Box mt={2} mb={5}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link to="/" className={classes.link}>
                Home
              </Link>
              <Link to="/aktualnosci/" className={classes.link}>
                Aktualności
              </Link>
              <Typography className={classes.text}>{title}</Typography>
            </Breadcrumbs>
          </Box>
          {image && (
            <GatsbyImage
              image={getImage(image)}
              alt="Zdjęcie aktualności"
              className={classes.image}
            />
          )}
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>
          {/* {date && (
            <Typography variant="h2" className={classes.date}>
              <EventNoteIcon fontSize="small" className={classes.icon} />
              {date}
            </Typography>
          )} */}
          <Typography
            variant="body1"
            component="div"
            className={classes.body}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Container>
      </Box>
    </Layout>
  )
}

export const query = graphql`
  query querySingleBlog($id: String!) {
    datoCmsNews(id: { eq: $id }) {
      title
      seo {
        title
        description
      }
      date(formatString: "YYYY.MM.DD")
      description
      image {
        gatsbyImageData(layout: CONSTRAINED, placeholder: DOMINANT_COLOR)
      }
    }
  }
`

export default SingleBlog
